module.exports = __webpack_public_path__ + "be098fe6c74421bbb1c9582baa5bf977.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_r_30.mp3
// module id = 428
// module chunks = 0